<template>
  <div class="invite-container">
    <div class="content">
      <!-- rtc 房间 -->
      <comp-room type="invite" :sdkAppId="Number(sdkAppId)" :inviteUserSig="userSig" :userId="userId" :roomId="Number(roomId)"></comp-room>
    </div>
  </div>
</template>

<script>
import CompRoom from "@/components/comp-rooms.vue";
import { getUrlParam } from "@/utils/utils.js";
import { getuserSign } from "../axios/api.js";

export default {
  name: "InviteApp",
  data () {
    return {
      sdkAppId: 0,
      userSig: "",
      userId: "",
      roomId: 0
    };
  },
  methods: {
    getusersign () {
      // console.log(getUrlParam("79778"));
      const params = {
        userId: this.userId
      };
      getuserSign(params).then(res => {
        if (res && res.code === 200) {
          this.userSig = res.data;
          // console.log(11);
          // window.open("https://ivatest.terabits.cn" + res.data);
        }
      });
    }
  },
  components: {
    CompRoom
  },
  mounted () {
    this.sdkAppId = Number(1600119414);
    // this.userSig = getUrlParam("userSig");
    this.userId = getUrlParam("userId");
    this.roomId = Number(getUrlParam("roomId"));
    // clearUrlParam();
  },
  created () {
    this.userId = (window.location.search.split('userId='))[1];
    this.getusersign();
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 80%;
  margin: 0 auto;
  max-width: 1320px;
  padding-top: 60px;
  &.content-mobile {
    width: 100%;
    padding: 30px 16px 20px;
  }
  .invite-tips {
    width: 100%;
    height: 60px;
    color: #084298;
    background-color: #cfe2ff;
    position: relative;
    padding: 1rem 1rem;
    margin-bottom: 1rem;
    border: 1px solid #b6d4fe;
    border-radius: 0.25rem;
  }
}
</style>

<i18n>
{
	"en": {
		"You've been invited to a video call": "You've been invited to a video call!"
	},
	"zh": {
		"You've been invited to a video call": "你被邀请参加视频通话！"
	}
}
</i18n>
